<section class="record">
    <span ng-click="toggleDetails()">
        <span class="details-toggle" ng-class="{open:showDetails}"><i class="fa fa-angle-right"></i></span>
        <span c-activity-log-blurb activity="activity"></span>{{"extendAuditDate.message"|translate}}
        <span class="tag">{{AuditDate | cDate}}</span>
    </span>
</section>
<section class="details" c-toggle="showDetails">
    <section class="message-section" c-activity-log-message activity="activity"></section>
</section>
